import { type HttpClientConfig, isHttpClientError } from 'core/infra/http/HttpClient'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

type GetOpenDockCarrierIdFactoryDependencies = {
  repository: ShipmentRepository
}

type Params = {
  shipmentUUID: string
  config: Partial<HttpClientConfig>
}

export function getOpenDockCarrierIdFactory({
  repository,
}: GetOpenDockCarrierIdFactoryDependencies) {
  return async function getOpenDockCarrierId({ shipmentUUID, config }: Params) {
    try {
      return await repository.getOpenDockCarrierId(shipmentUUID, config)
    } catch (error) {
      // A 404 means the carrier is not signed up in OpenDock yet, which is an
      // expected state that drives the "create account" step, not an error.
      if (isHttpClientError(error) && error.response?.status === 404) {
        return null
      }
      throw new Error('Could not get OpenDock carrier', { cause: error as Error })
    }
  }
}

export function getOpenDockCarrierId({ shipmentUUID, config }: Params) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const newGetOpenDockCarrierId = getOpenDockCarrierIdFactory({
    repository,
  })
  return newGetOpenDockCarrierId({ shipmentUUID, config })
}
